
<p *ngIf="layout === 'normal'" class='active singlecheckbox'>
    <label class='fakelabel' [ngStyle]="mandatory && {'display': 'inline-block'}">{{labelInput}}</label> <span
        *ngIf="mandatory" class="mandatory">*</span>
    <input type='checkbox' id="{{(idInput ? idInput: 'checkbox') + '_' + randomValueString}}"
        [(ngModel)]="internalObject" (change)="onChange()" [disabled]="submitPending" />
    <ng-template [ngIf]="showLabel">
        <label for="{{(idInput ? idInput: 'checkbox') + '_' + randomValueString}}"
            [ngStyle]="(mandatory && {'display': 'block'}) || (labelSemibold && {'font-family': 'open_sans_semibold'})">
            {{internalObject ? (labelChecked ? labelChecked : 'Si') : (labelNotChecked ? labelNotChecked : 'No')}}
        </label>
    </ng-template>
    <ng-template [ngIf]="!showLabel">
        <label for="{{(idInput ? idInput: 'checkbox') + '_' + randomValueString}}"
            [ngStyle]="mandatory && {'display': 'block'}">
            <small class="sr-only">{{labelInput}}</small>
        </label>
    </ng-template>
</p>


<p *ngIf="layout === 'no-label'" class='active singlecheckbox'>
    <small class="sr-only" id="radio_{{idInput}}">{{labelInput}}</small>
    <label class='fakelabel' [ngStyle]="mandatory && {'display': 'inline-block'}">
        <span class="sr-only">{{labelInput}}</span>
    </label> 
    <span *ngIf="mandatory" class="mandatory">*</span>
    <input type='checkbox' aria-labelledby="radio_{{idInput}}" id="{{(idInput ? idInput: 'checkbox') + '_' + randomValueString}}"
        [(ngModel)]="internalObject" (change)="onChange()" [disabled]="submitPending" />
    <ng-template [ngIf]="showLabel">
        <label for="{{(idInput ? idInput: 'checkbox') + '_' + randomValueString}}"
            [ngStyle]="(mandatory && {'display': 'block'}) || (labelSemibold && {'font-family': 'open_sans_semibold'})">
            {{internalObject ? (labelChecked ? labelChecked : 'Si') : (labelNotChecked ? labelNotChecked : 'No')}}
        </label>
    </ng-template>
    <ng-template [ngIf]="!showLabel">
        <label for="{{(idInput ? idInput: 'checkbox') + '_' + randomValueString}}" 
            [ngStyle]="mandatory && {'display': 'block'}">
            <span class="sr-only">{{labelInput}}</span>
        </label>
    </ng-template>
</p>

<p *ngIf="layout === 'label-next'" class='active singlecheckbox'>
    <label class='fakelabel' [ngStyle]="mandatory && {'display': 'inline-block'}">
        <span class="sr-only">{{labelInput}}</span>
    </label>
    <span *ngIf="mandatory" class="mandatory">*</span>
    <input type='checkbox'
        id="{{(idInput ? idInput: 'checkbox') + '_' + randomValueString}}" [(ngModel)]="internalObject"
        (change)="onChange()" [disabled]="submitPending" />
    <label for="{{(idInput ? idInput: 'checkbox') + '_' + randomValueString}}"
        [ngStyle]="mandatory && {'display': 'block'}">
        <strong>{{labelInput}}</strong>
    </label>
</p>


